import { Box, useTheme } from '@mui/material';
import { keyframes } from '@emotion/react';
import { RotorScadaIcon } from 'src/assets/icons/SCADA/assetsComponents/RotorScadaIcon';

type Props = {
  width?: number;
  height?: number;
  isAlarmActive: boolean;
  isRunMode: boolean;
};

const rotate = keyframes`
0% { transform: translate(-50%, -50%) rotate(0deg); }
100% { transform: translate(-50%, -50%) rotate(360deg); }
`;

export const RotorElement = ({ width, height, isAlarmActive, isRunMode }: Props) => {
  const theme = useTheme();
  const primaryMainColor = theme.palette.primary.main;
  const greyColor = theme.palette.grey[400];
  const redColor = '#ff4842';

  let propelerColor = greyColor;
  let testId = 'offState';

  if (isAlarmActive) {
    propelerColor = redColor;
    testId = `activeAlarm-${isRunMode ? 'onState' : 'offState'}`;
  } else if (isRunMode && !isAlarmActive) {
    propelerColor = primaryMainColor;
    testId = 'onState';
  }

  const widthOfElement = width ? width : 50;
  const heightOfElement = height ? height : 50;

  return (
    <Box
      data-sm={testId}
      position="relative"
      sx={{
        width: widthOfElement,
        height: heightOfElement,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          animation: isRunMode ? `${rotate} 1.5s linear infinite` : 'none',
          width: widthOfElement,
          height: heightOfElement,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <RotorScadaIcon width={widthOfElement} height={heightOfElement} fill={propelerColor} />
      </Box>
    </Box>
  );
};
